/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfProductFromDiscriminatorValue, serializeGetProductsBySkusRequest, serializePagedResultOfProduct, type ErrorResponse, type GetProductsBySkusRequest, type InternalErrorResponse, type PagedResultOfProduct } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/products/batch
 */
export interface BatchRequestBuilder extends BaseRequestBuilder<BatchRequestBuilder> {
    /**
     * Get multiple Products by their SKUs
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfProduct>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: GetProductsBySkusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PagedResultOfProduct | undefined>;
    /**
     * Get multiple Products by their SKUs
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: GetProductsBySkusRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BatchRequestBuilderUriTemplate = "{+baseurl}/api/products/batch";
/**
 * Metadata for all the requests in the request builder.
 */
export const BatchRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BatchRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfProductFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeGetProductsBySkusRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
